<template>
  <v-row justify="center" class="pt-10">
    <v-card
      max-width="700"
      width="80vw"
      min-height="500"
      class="px-5 py-3 overflow-x-hidden overflow-y-auto custom-scroll"
      max-height="80vh"
    >
      <v-card-title>Lesson Name</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field dense v-model="name" />
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="readyTeacher"
              :loading="loading"
              :readonly="$store.state.profile.role === 'EDITOR'"
              label="Live Lesson Ready"
            />
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="readyPractice"
              :loading="loading"
              :readonly="$store.state.profile.role === 'EDITOR'"
              label="Lesson Practice Ready"
            />
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="readyGrammar"
              :loading="loading"
              :readonly="$store.state.profile.role === 'EDITOR'"
              label="Sentence Structure Ready"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-btn
        v-if="$store.state.profile.role === 'ADMIN'"
        text
        @click="onSave"
        :loading="loading"
        color="#FF347C"
        class="d-flex ml-auto"
        >Save</v-btn
      >
    </v-card>
  </v-row>
</template>
<script>
import { patchLesson, patchReady } from "@/api/api";

export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      name: this.$store.getters["admin/lesson"].name,
      loading: false,
      readyTeacher: this.$store.getters["admin/teacher_lesson"].ready,
      readyPractice: this.$store.getters["admin/practice"].ready,
      readyGrammar: this.$store.getters["admin/grammar"].ready,
    };
  },
  computed: {
    lesson() {
      return this.$store.getters["admin/lesson"];
    },
  },
  methods: {
    async onSave() {
      this.loading = true;
      const response = await patchLesson(this.lesson.uuid, { name: this.name });
      if (response) {
        this.$emit("edited-lesson", response.data);
      }
      const teacher = await patchReady(
        this.readyTeacher,
        "teach/teacherlessons",
        this.$store.getters["admin/teacher_lesson"].uuid,
      );
      if (!teacher) {
        this.readyTeacher = !this.readyTeacher;
      }
      const practice = await patchReady(
        this.readyPractice,
        "practice/practices",
        this.$store.getters["admin/practice"].uuid,
      );
      if (!practice) {
        this.readyPractice = !this.readyPractice;
      }
      const grammar = await patchReady(
        this.readyGrammar,
        "grammar/grammars",
        this.$store.getters["admin/grammar"].uuid,
      );
      if (!grammar) {
        this.readyGrammar = !this.readyGrammar;
      }
      this.loading = false;
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.name = this.$store.getters["admin/lesson"].name;
        this.readyTeacher = this.$store.getters["admin/teacher_lesson"].ready;
        this.readyPractice = this.$store.getters["admin/practice"].ready;
        this.readyGrammar = this.$store.getters["admin/grammar"].ready;
      }
    },
  },
};
</script>
